import { render, staticRenderFns } from "./ManPositionTitle.vue?vue&type=template&id=4c1bd8cc&scoped=true"
import script from "./ManPositionTitle.vue?vue&type=script&lang=js"
export * from "./ManPositionTitle.vue?vue&type=script&lang=js"
import style0 from "./ManPositionTitle.vue?vue&type=style&index=0&id=4c1bd8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1bd8cc",
  null
  
)

export default component.exports